// @core/api/endpoints/project/update_label.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LabelResponse,
  UpdateLabelRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update label
 * Updates label name or color. Changes apply retroactively to all items with this label.
 */
export async function UpdateLabel(
  project_id: string,
  label_id: string,
  data: UpdateLabelRequest,
  options?: RequestOptions
): Promise<LabelResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/labels/:label_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':label_id', encodeURIComponent(label_id));
  const requestOptions = options;
  return client.put<LabelResponse>(requestPath, data, requestOptions);
}
